/**
 * Single navigation boundary for full-page redirects.
 *
 * jsdom makes window.location.href non-configurable, so sagas that assign to it
 * cannot be observed in tests. Routing every redirect through this function gives
 * tests one seam to mock and assert on.
 *
 * @param {string} url Absolute URL to navigate the browser to.
 */
export function redirectTo(url) {
  window.location.href = url;
}
